// extracted by mini-css-extract-plugin
module.exports = {"list-item":"style_list-item__3DzIs"};